// The start page's next match, in the visitor's own time zone with how long until it starts ("in 25 minutes"). With
// the Upcoming matches list from the HLTV feed, the game is picked again by the visitor's clock and once a minute: the
// next game to start, which stays up as "Live now" for three hours (a whole day when only the date is known). On a day
// with several games, the next one takes over from 30 minutes before it starts. Ported from the approved concept
// (concept/src/09-pages.js).
import { $ } from 'fx';

const SOON = 30 * 60e3;
const HOUR = 3600e3;
const liveFor = (m) => (m.timePrecision === 'date' ? 24 : 3) * HOUR;
const dayOf = (m) => m.date || String(m.startsAt).slice(0, 10);

// pick-next:start
// The game to show at `now`: the first one that isn't over yet, unless a later game on the same day starts within
// 30 minutes (then the latest of those). Games are sorted by start time first.
export function pickNext(list, now) {
  const games = (Array.isArray(list) ? list : [])
    .filter((m) => m && Number.isFinite(Date.parse(m.startsAt)))
    .sort((a, b) => Date.parse(a.startsAt) - Date.parse(b.startsAt));
  let pick = null;
  for (const m of games) {
    const starts = Date.parse(m.startsAt);
    if (starts + liveFor(m) <= now) continue;
    if (!pick) pick = m;
    else if (starts <= now + SOON && dayOf(m) === dayOf(pick)) pick = m;
  }
  return pick;
}
// pick-next:end

const box = $('[data-match]');
if (box) {
  const T = JSON.parse(($('#start-strings') || {}).textContent || '{}');
  let list = [];
  try { list = JSON.parse(($('#start-matches') || {}).textContent || '[]') || []; } catch (e) { list = []; }
  const typed = { starts: Number(box.dataset.starts) * 1000, dateOnly: box.dataset.dateOnly === 'true' };
  let shown = null;

  const render = () => {
    const now = Date.now();
    let starts = typed.starts;
    let dateOnly = typed.dateOnly;
    let live = 3 * HOUR;
    const next = list.length ? pickNext(list, now) : null;
    if (next) {
      starts = Date.parse(next.startsAt);
      dateOnly = next.timePrecision === 'date';
      live = liveFor(next);
      if (shown !== next) {
        shown = next;
        $('[data-match-opp]', box).textContent = next.opponent || T.tba || 'TBA';
        $('[data-match-event]', box).textContent = next.event || ''; // the " · " after it comes from the CSS
        const link = $('[data-match-link]', box);
        if (next.url) {
          link.href = next.url;
          const label = $('[data-hltv]', link);
          label.textContent = next.url.includes('hltv.org') ? label.dataset.hltv : label.dataset.other;
        }
        link.hidden = !next.url;
        const format = $('[data-match-format]', box);
        if (format) format.textContent = next.format || '';
      }
    } else if (list.length) {
      starts = NaN; // every listed game is over
    }

    const diff = starts - now;
    if (!Number.isFinite(starts) || !starts || diff <= -live) {
      box.hidden = true;
      return;
    }
    box.hidden = false;
    const time = $('[data-match-time]', box);
    const when = new Date(starts);
    time.dateTime = when.toISOString();
    try {
      time.textContent = new Intl.DateTimeFormat('en-GB', dateOnly
        ? { weekday: 'short', day: 'numeric', month: 'short' }
        : { weekday: 'short', day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit', timeZoneName: 'short' }).format(when);
    } catch (e) { /* keep the store's own time */ }
    const rel = $('[data-match-when]', box);
    let text = '';
    if (diff < 0) text = T.now || 'Live now';
    else {
      try {
        const rtf = new Intl.RelativeTimeFormat('en', { numeric: 'auto' });
        if (dateOnly || diff >= 24 * HOUR) text = rtf.format(Math.round(diff / (24 * HOUR)), 'day');
        else if (diff >= HOUR) text = rtf.format(Math.round(diff / HOUR), 'hour');
        else text = rtf.format(Math.max(1, Math.round(diff / 60e3)), 'minute');
      } catch (e) { /* no relative time */ }
    }
    rel.textContent = text ? ` · ${text}` : '';
    rel.hidden = !text;
  };

  render();
  setInterval(() => { if (!document.hidden) render(); }, 60e3);
}
